/* External */
import defaultsDeep from 'lodash-es/defaultsDeep';
import { resolveWhenConnectionAvailable } from '../providers/ConnectionStatusProvider';

/* Services */
import aemService from '../services/aemService';

/* Utils */
import { Country, DEFAULT_AEM_CONFIG, STORAGE_COUNTRY } from './constants';
import { createDeferredPromise } from './createDeferredPromise';
import platform from './platform';

let config;
let configPromise;

const CONFIG_FETCH_TIMEOUT_MS = 10_000;

function createConfigFetchTimeout() {
  return new Promise((_resolve, reject) => {
    setTimeout(() => {
      reject(new Error('Config fetch timed out'));
    }, CONFIG_FETCH_TIMEOUT_MS);
  });
}

export async function getConfig() {
  if (!config && !configPromise) {
    try {
      configPromise = createDeferredPromise();
      await resolveWhenConnectionAvailable();

      const response = await Promise.race([
        aemService.config.getConfig(platform.aemPlatform),
        createConfigFetchTimeout(),
      ]);

      config = defaultsDeep({}, response?.data, DEFAULT_AEM_CONFIG);
      localStorage.setItem(STORAGE_COUNTRY, response?.data?.userCountry);
      configPromise.resolve(config);
    } catch (error) {
      console.error('configUtils>getConfig error', error);
      config = DEFAULT_AEM_CONFIG;
      configPromise.resolve(config);
    }
  }
  return config || configPromise.promise;
}

export async function getCountry() {
  const { userCountry } = await getConfig() || {};
  return userCountry;
}

export async function getUserCountry() {
  let userCountry;
  try {
    await resolveWhenConnectionAvailable();
    const response = await aemService.config.getCountry();
    userCountry = response?.data;
    localStorage.setItem(STORAGE_COUNTRY, response?.data?.userCountry);
  } catch (error) {
    console.error('configUtils>getUserCountry error', error);
  }
  return userCountry;
}

export async function getIsBrazil() {
  return (await getCountry()) === Country.BRAZIL;
}

export function isBrazil() {
  return config?.userCountry === Country.BRAZIL;
}
